import {Route} from 'react-router'
import {SearchFirm} from './firm'
import {SearchInvoice} from './invoice'
import {SearchUser} from './user'

export const routes = (
	<Route path="/search">
		<Route path="firm" element={<SearchFirm />} />
		<Route path="user" element={<SearchUser />} />
		<Route path="invoice" element={<SearchInvoice />} />
	</Route>
)
